import { ActivatedRoute, Router } from '@angular/router';
import { AjaxOptions, Options } from 'select2';
import { AlertService } from 'src/app/services/alert.service';
import { AppHttpService } from 'src/app/services/app-http.service';
import { AauthService } from 'src/app/services/aauth.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterContentChecked, ChangeDetectorRef} from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { DbdataService } from '../../../services/dbdata.service';
import { DBkeys } from '../../../services/db-keys';
import { LocalStoreManager } from 'src/app/services/local-store-manager.service';
import { RegisterService } from '../register.service';
import { Subject } from 'rxjs';

declare function InitMyJs(): void; // fake to skip ide error.

@Component({
  selector: 'app-register2',
  templateUrl: './register2.component.html',
  styleUrls: ['./register2.component.scss']
})
export class Register2Component implements OnInit, AfterViewInit, AfterContentChecked {
  public select2Options: Options;
  private select2AjaxOptions: AjaxOptions;

constructor(
    public aauthService: AauthService,
    private dbDataService: DbdataService,
    private configurations: ConfigurationService,
    private localStorage: LocalStoreManager,
    private alertService: AlertService,
    private dbData: DbdataService,
    public registerService: RegisterService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router)
  {  }

  isFlyout = this.registerService._isFlyout;
  dbCountries = null;
  dbTitles = null;
  dbStates = null;
  dbReferrers = null;
  pId = 0;
  isClaim = false;
  corp = 0;
  lastStepCompleted = 0;
  validpassword = true;
  passwordsmatch = true;
  dataReady = false;

  @ViewChild('corporateType', { static: true}) corporateTypeElem: ElementRef;
  @ViewChild('individualType', { static: true}) individualTypeElem: ElementRef;

  ngOnInit(): void {
    try {
      InitMyJs();
    } catch (error) {
      console.error(error);
    }
    this.isClaim = this.localStorage.getData(DBkeys.LOCAL_KEY_ISCLAIM);
    this.pId = this.localStorage.getData(DBkeys.LOCAL_KEY_PID);
    this.corp = this.localStorage.getData(DBkeys.LOCAL_KEY_CORP);
    this.lastStepCompleted = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'step');
    this.loadReferralTypeahead();
  }

  ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
      if (this.lastStepCompleted > 2) { //if last step > then this only reload
        this.initialize();
        this.dataReady = true;
      }
      else {
        if (this.isClaim) {
          this.processIsClaim();
        }
        else {
          this.initialize();
          this.dataReady = true;
        }
      }
      this.triggerCorpTypeClick(this.corp);
    }, 500);
  }

  initialize() {
    if (this.dbCountries == null) {
      this.getCountries();
    }

    const mCorP  = this.aauthService.regModel2.corpType || 1;
    this.aauthService.formModel2.get('email').setValue(this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'email'));
    this.aauthService.formModel2.get('corpType').setValue(mCorP);
    this.getSavedModelValues();
    this.select2AjaxOptions = {
      url: (params) => this.getProfessionnalByNameUrl,
      dataType: 'json',
      delay: 450,
      cache: false,
      data: (params: any) => {
          console.log('Param', params);
          return {
            likeName: params.term,
            maxNames: 25,
            type: 1,
            page: params.page
          };
      },
      processResults: (data: any, params: any) => {
          params.page = params.page || 1;
          console.log('data: ', data);
          return {
                results: data.items,
                pagination: {
                    more: (params.page * 30) < data.total_count
                }
          };
      },
    };

    this.select2Options = {
      ajax: this.select2AjaxOptions,
      placeholder: 'Select a referring member',
      escapeMarkup(markup: any) { return markup; },
      minimumInputLength: 3,
      templateResult: this.formatMember,
      templateSelection: this.formatMemberSelection
    };

    // fix css layout, by click on label for select radio input
    setTimeout(() => {
      this.defaultSelectRadio();
      this.getProfessionals('');
    }, 50);
    this.dataReady = true;
  }
  async processIsClaim()
  {
    try {
    const response = await this.aauthService.signupWithEmail(this.pId, this.corp, true);
    this.getSavedModelValues();
    this.dataReady = true;
    this.initialize();
    }
    catch (error) {
      this.dataReady = true;
    }
  }

  async loadReferralTypeahead() {

  }

  getSavedModelValues(dataModel = null) {
    try {
      if (dataModel == null) {
        const datalocal = this.localStorage.getData(DBkeys.LOCAL_KEY_REG);
        if (datalocal !== null) {
          dataModel = JSON.parse(datalocal).professionalModel;
          if (dataModel === null || dataModel === undefined) {
            dataModel = JSON.parse(datalocal);
          }
        }
      }
      if (dataModel !== null) {
        var countryId = '';
        //this.aauthService.formModel2.get('MemberType').setValue(dataModel.memberType == 5 ? 5 : 1);
        this.aauthService.formModel2.get('firstName').setValue(dataModel.firstName);
        this.aauthService.formModel2.get('lastName').setValue(dataModel.lastName);
        if (dataModel.addressViewModel != null) {
          countryId = dataModel.addressViewModel.Country;
          this.aauthService.formModel2.get('address').setValue(dataModel.addressViewModel.Address);
          this.aauthService.formModel2.get('city').setValue(dataModel.addressViewModel.City);
          this.aauthService.formModel2.get('postalCode').setValue(dataModel.addressViewModel.PostalCode);
          this.dbCountries = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'countries');
          this.dbTitles = this.localStorage.getData(DBkeys.LOCAL_KEY_REG + 'titles');
          this.onGetStatesByCountry(countryId);
          this.aauthService.formModel2.get('country').setValue(countryId);
          this.aauthService.formModel2.get('state').setValue(dataModel.addressViewModel.State);
          this.aauthService.formModel2.get('title').setValue(dataModel.title);
        }
        else {
          countryId = dataModel.country;
          this.aauthService.formModel2.get('country').setValue(countryId);
          this.aauthService.formModel2.get('address').setValue(dataModel.address);
          this.aauthService.formModel2.get('city').setValue(dataModel.city);
          this.aauthService.formModel2.get('state').setValue(dataModel.state);
          this.aauthService.formModel2.get('postalCode').setValue(dataModel.postalCode);
          this.aauthService.formModel2.get('title').setValue(dataModel.title);
          this.dbTitles = dataModel.titles;
          this.dbCountries = dataModel.countries
          this.dbStates = dataModel.states;
        }
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  formatMember(member: any) {
    if (member.loading) { return member.text; }
    let markup = '<div class=\'select2-result-repository clearfix\' data-id=\'' + member.id + '\' data-text=\'' + member.formattedName + '\'>' +
      //data-id='" + member.id + "' onclick='selectListItem(" + member.id + ");'
      '<div class=\'select2-result-repository__avatar\'><img alt=\'Profile Image\' src=\'' + member.profileImage + '\' /></div>' +
      '<div class=\'select2-result-repository__meta\'>' +
        '<div class=\'select2-result-repository__title\'>' + member.formattedName + '</div>';

    if (member.formattedAddress) {
        markup += '<div class=\'select2-result-repository__description\'>' + member.formattedAddress + '</div>';
    }

    markup += '</div></div>';
    return markup;
    }

  formatMemberSelection(data: any) {
      return data.formattedName || data.text;
  }

  getCountries() {
    this.dbDataService.getCountries()
    .subscribe ({
      next: (data: any) => {
        if (this.dbCountries == null) {
          this.dbCountries = data;
        }
      },
      error: (error: any) => console.error(error)
    });
  }

  getTitles() {
    this.dbDataService.getTitles()
    .subscribe ({
      next: (data: any) => {
        this.dbTitles = data;
        // console.log(data);
      },
      error: (error: any) => console.log(error)
    });
  }

  private defaultSelectRadio() { // fix css layout, by click on label for select radio input.
    let ctrlSelect2: HTMLElement;
    if (this.aauthService.regModel2.corpType === 0) { // Don't use "===" for this .... ?
      ctrlSelect2 = document.getElementById('lbRegisterCompany');
    } else {
      ctrlSelect2 = document.getElementById('lbRegisterIndividual');
    }
    if ((ctrlSelect2 !== undefined) && (ctrlSelect2 !== null)) {
      ctrlSelect2.click();
    }
  }

  get getProfessionnalByNameUrl() {
    return this.configurations.apiUrl + '/Professional/GetNamesLike';
  }

  getProfessionals(pName: string) {
    this.dbDataService.getProfessionals(pName)
    .subscribe ({
      next: (data: any) => {
        this.dbReferrers = data.Items;
      },
      error: (error: any) => console.log(error)
    });
  }

  onCountryChange($event: any) {
    const countryId = $event.target.value;
    this.onGetStatesByCountry(countryId);
  }

  onGetStatesByCountry(countryId) {
    this.dbDataService.getStatesByCountry(countryId)
      .subscribe({
        next: data => {
          this.dbStates = data;
          if (data != null) {
            this.aauthService.saveStates(data);
          }
        },
        error: error => console.log(error)
      });
  }

  onPostalCodeChange(event: any) {
    this.dbData.getAddressByPostalCode(this.f.country.value, this.f.postalCode.value).subscribe(
      (data: any) => {
        this.f.state.setValue(data.State);
        this.f.city.setValue(data.City);
      },
      error => { console.error(error); }
    );
  }

  radioChangeHandler(event: any) {
    this.aauthService.regModel2.corpType = event.target.value;
  }

  onCheckboxAgree(event: any) {
    this.aauthService.regModel2.agree = event.target.value;
  }

  gotoTermsOfUse() {
    this.aauthService.gotoTermsOfUse();
  }

  gotoPrivacyPolicy() {
    this.aauthService.gotoPrivacyPolicy();
  }

  onSubmit() {
    if (this.lastStepCompleted > 2) {
      this.registerService.regStep = 3;
      this.router.navigateByUrl('/register/step3');
    }
    else {
      this.aauthService.saveCountries(this.dbCountries);
      this.aauthService.saveTitles(this.dbTitles);
      this.aauthService.register(this.aauthService.regModel2.corpType);
    }
  }

  isEmailInvalid() {
    return this.aauthService.formModel2.get('email').invalid;
  }

  async reCaptchaResolved(captchaResponse: string) {
      await this.sendCaptchaToBackend(captchaResponse);
  }

  sendCaptchaToBackend(captcha: any) {
    this.aauthService.sendCaptchaToBackend(captcha).subscribe(
      (data: any) => {
      },
      error => {
        const ctrl =  this.aauthService.formModel2.get('recaptcha');
        ctrl.reset();
        this.alertService.showError(error);
      }
    );
  }

  get f() {
    return this.aauthService.formModel2.controls;
  }

  get AgreeCtrl() {
    return this.aauthService.formModel2.get('agree');
  }

  passwordValid() {
    const formModel = this.aauthService.formModel2;
    const ucase = new RegExp("[A-Z]+");
    const num = new RegExp("[0-9]+");
    const password = formModel.value.passwords.password;
    const isBlank = password === '';
    if (isBlank) {
      return true;
    }
    const invalidLen = isBlank || (password.length < 6);
    const invalidChars = !(ucase.test(password) && num.test(password) && !(/^[a-zA-Z0-9- ]*$/.test(password)));
    this.validpassword = !isBlank && !invalidLen && !invalidChars;
    return this.validpassword;
  }

  confirmPasswordValid() {
    let pwdMatch = false;
    const formModel = this.aauthService.formModel2;
    const password = formModel.value.passwords.password;
    const cfmPassword = formModel.value.passwords.confirmPassword;
    if (password === cfmPassword) {
      pwdMatch = true;
    }
    this.passwordsmatch = pwdMatch;
    return this.passwordsmatch;
  }

  triggerCorpTypeClick(type){
    switch(type)
    {
      case 1:
        //this.individualTypeElem.nativeElement.click();
        break;
      default:
        //this.corporateTypeElem.nativeElement.click();
        break;
    }
  }
}
